import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useTokenContext } from "../../../context/tokenContext";
import { useNavigate, useParams } from "react-router-dom";
import {
  getMissions,
  getWorkingFolders,
} from "../../../services/Api/customerService";
import PartnerMissionTable from "../../../components/Cac/Partner/Mission/PartnerMissionTable";
import folder from "../../../assets/icons/folderBlue.svg";
import { usePartnerMissionStore } from "../../../stores/Cac/Partner/partnerMission";
import PartnerModalCreateUpdateMission from "../../../components/Cac/Partner/Mission/PartnerModalCreateUpdateMission";
import PartnerModalArchiveMission from "../../../components/Cac/Partner/Mission/PartnerModalArchiveMission";
import PopupLimitMission from "../../../components/Cac/Partner/Mission/PopupLimitMission";
import { renameFileWithoutUnderscore } from "../../../services/Utils/functionService";
import SideBar from "../../../components/Layout/SideBar";
import { usePartnerWorkingFolderStore } from "../../../stores/Cac/Partner/partnerWorkingFolder";
import CreateWorkingFolder from "../../../components/Cac/Partner/WorkingFolder/CreateWorkingFolder";
import Header from "../../../components/Layout/Header";
import Footer from "../../../components/Layout/Footer";
import { showToastError } from "../../../services/Toasts/toasts";

const PartnerMissions = () => {
  const { t } = useTranslation();
  // Context
  const { roleId } = useTokenContext();

  // Hooks
  const navigate = useNavigate();
  const { idPartner, idCustomer } = useParams();

  // Store
  const {
    missions,
    setMissions,
    choiceModal,
    setChoiceModal,
    errorLimitMission,
    updateMission,
  } = usePartnerMissionStore();
  const { choiceModalWF, setChoiceModalWF, workingFolder, setWorkingFolder } =
    usePartnerWorkingFolderStore();

  // Function for get missions
  useEffect(() => {
    getMissions(Number(idCustomer))
      .then((data) => setMissions(data.missions))
      .catch(() => showToastError(t("common.error")));
    getWorkingFolders(Number(idCustomer))
      .then((data) => setWorkingFolder(data[0]))
      .catch(() => showToastError(t("common.error")));
  }, [idCustomer, choiceModal, updateMission]);

  return (
    <div className="flex h-dvh w-full flex-col overflow-hidden bg-gradient-to-br from-slate-50 to-blue-50">
      <Header />
      <div className="flex min-h-0 flex-1 overflow-hidden">
        <SideBar />
        <main className="flex min-h-0 flex-1 scroll-pb-24 flex-col overflow-y-auto pb-24 pt-3 sm:scroll-pb-20 sm:pl-14 md:pb-20">
          <div className="mx-auto flex min-h-0 w-full max-w-7xl flex-1 flex-col gap-3 px-3 lg:px-4 2xl:max-w-[2400px]">
          {/* Header Section avec design moderne */}
          <section className="w-full flex-shrink-0 rounded-2xl border border-gray-100 bg-white p-4 shadow-md sm:p-5">
            <div className="flex flex-col items-start justify-between gap-4 lg:flex-row lg:items-center">
              <div className="flex min-w-0 items-center gap-3 sm:gap-4">
                <div className="hidden md:flex flex-shrink-0 rounded-xl bg-yellow-trio p-2.5 sm:p-3">
                  <svg className="h-5 w-5 text-grey-trio sm:h-6 sm:w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div>
                  <h1 className="font-K2D text-lg font-bold text-gray-700 sm:text-xl">
                    {t("partner.missionsTitle")} : <span className="text-yellow-trio">{missions?.length > 0 ? renameFileWithoutUnderscore(missions[0].name) : ""}</span>
                  </h1>
                  <p className="mt-1 text-sm text-gray-600 sm:text-base">
                    {t("partner.missionsSubtitle")}
                  </p>
                </div>
              </div>
              
              <div className="flex w-full flex-col gap-2 sm:flex-row sm:flex-wrap sm:gap-3 lg:w-auto lg:justify-end">
                {!workingFolder && roleId !== 2 && (
                  <button
                    type="button"
                    className="flex min-h-11 w-full cursor-pointer items-center justify-center gap-2 rounded-xl bg-yellow-trio px-5 py-2 text-sm font-semibold text-gray-700 shadow-md transition-all duration-200 hover:shadow-lg sm:w-auto sm:text-base"
                    onClick={() => setChoiceModalWF("create")}
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z" />
                    </svg>
                    {t("partner.createWorkingFolder")}
                  </button>
                )}
                {workingFolder !== undefined && (
                  <button
                    className="flex min-h-11 w-full cursor-pointer items-center justify-center gap-2 rounded-xl bg-light-lavender bg-opacity-20 px-4 py-2 shadow-md transition-all duration-200 hover:shadow-lg sm:w-auto"
                    onClick={() =>
                      navigate(
                        `/partner/${idPartner}/customers/${idCustomer}/workingfolder/${workingFolder?.id}`
                      )
                    }
                  >
                    <img src={folder} alt="dossier" className="w-5 h-5" />
                    <span className="min-w-0 truncate text-sm text-grey-trio lg:text-base">
                      {t("partner.workingFolder")} :{" "}
                      <span className="font-bold">
                        {workingFolder?.CategoryMission?.name} -{" "}
                        {workingFolder?.exercice}
                      </span>
                    </span>
                  </button>
                )}
                {roleId !== 2 && (
                  <button
                    type="button"
                    className="flex min-h-11 w-full cursor-pointer items-center justify-center gap-2 rounded-xl bg-yellow-trio px-5 py-2 text-sm font-semibold text-gray-700 shadow-md transition-all duration-200 hover:shadow-lg sm:w-auto sm:text-base"
                    onClick={() => setChoiceModal("create")}
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                    {t("partner.addMission")}
                  </button>
                )}
              </div>
            </div>
          </section>

          {/* Table des missions avec design moderne */}
          <section className="min-h-[24rem] w-full flex-1 overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-md">
            <PartnerMissionTable />
          </section>
          </div>
        </main>
      </div>
      
      {/* Modals */}
      {choiceModal === "create" || choiceModal === "update" ? (
        <PartnerModalCreateUpdateMission />
      ) : choiceModalWF === "create" ? (
        <CreateWorkingFolder />
      ) : null}
      {errorLimitMission ? <PopupLimitMission /> : null}
      {choiceModal === "archive" ? <PartnerModalArchiveMission /> : null}
      
      <Footer />
    </div>
  );
};

export default PartnerMissions;
